import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

/* Chakra v3 system. Ported from goblin-fe shared/theme. Brand tokens
   for the admin (teal) live in tokens.css for the legacy mini-kit; the
   Chakra theme keeps the default palette plus our breakpoint scale until
   pages are migrated and we map brand colors into semantic tokens. */

const config = defineConfig({
  ...defaultConfig,
  // Brand is teal (matches tokens.css --color-primary). Make it the
  // default color palette so primary buttons/badges/focus rings inherit
  // it instead of Chakra's neutral gray.
  globalCss: {
    html: { colorPalette: 'teal' },
  },
  theme: {
    ...defaultConfig.theme,
    breakpoints: {
      sm: '30em',
      md: '48em',
      lg: '62em',
      xl: '80em',
      '2xl': '96em',
      '3xl': '103em',
    },
  },
});

export const system = createSystem(config);
